



import { Component, Vue } from 'vue-property-decorator';
import Zoom from '../../assets/zoom.svg?inline';
@Component({
  components: {
    Zoom,
  },
})
export default class ZoomIcon extends Vue {}
